import { client } from '@/utils/apiClients';

/**
 * API function to send and confirm OTP
 */
export const sendAndConfirmOtp = async (body: any) => {

    try {
        const response = await client("/sendAndConfirmOtp", {
            body: body,
        });

        return response;
    } catch (error) {
        console.error("Error sending OTP:", error);
        throw error;
    }
}

/**
 * API function to get update location
 */
export const getUpdateLocation = async () => {
    try {
        const response = await client("/getUpdateLocation", {
            method: 'GET',
        });



        if (response && response.success) {

            return response.data;
        } else {
            throw new Error('Failed to fetch location');
        }
    } catch (error: any) {
        console.error('Error fetching location:', error);
        const errorMessage = error.message || 'Failed to fetch location';
        throw new Error(errorMessage);
    }
};

/**
 * Fetcher function for SWR
 */
export const fetcher = (url: string) => client(url, { method: 'GET' });
